<nz-page-header
  class="site-page-header"
  nzBackIcon
  [nzTitle]="idForUpdate ? 'Update Announcement' : 'Add Announcement'"
>
</nz-page-header>

<form nz-form [formGroup]="addUpdateAnnouncementForm">
  <nz-card class="mt3">
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
      <!-- Left Column: Fields -->
      <div nz-col nzLg="18" nzMd="18" nzSm="24" nzXs="24">
        <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
          <!-- Title -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Title</nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <input
                  nz-input
                  formControlName="title"
                  type="text"
                  placeholder="Enter Title"
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Redirect URL -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">Redirect Url</nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <input
                  nz-input
                  formControlName="redirectUrl"
                  type="url"
                  placeholder="Enter Url"
                />
                <span>
                  <small>
                    <i nz-icon nzType="info-circle" nzTheme="outline"></i>
                    <span>
                      URL should be in the format of
                      <span class="text-primary"
                        >https://mockshala.com/user-panel/freemocks</span
                      >
                      or
                      <span class="text-primary"
                        >https://mockshala.com/user-panel/plans</span
                      >
                    </span>
                  </small>
                </span>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- CTA Button -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24">CTA Button Text</nz-form-label>
              <nz-form-control [nzSpan]="24">
                <input
                  nz-input
                  formControlName="ctaButton"
                  type="text"
                  placeholder="e.g. Shop Now"
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Countdown Group -->
          <div
            nz-col
            nzLg="24"
            nzMd="24"
            nzSm="24"
            nzXs="24"
            formGroupName="countDown"
          >
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
              <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Enable Countdown</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <nz-switch formControlName="enabled"></nz-switch>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div
                nz-col
                nzLg="8"
                nzMd="8"
                nzSm="24"
                nzXs="24"
                *ngIf="
                  addUpdateAnnouncementForm.get('countDown.enabled')?.value
                "
              >
                <nz-form-item>
                  <nz-form-label [nzSpan]="24"
                    >Countdown End Time</nz-form-label
                  >
                  <nz-form-control [nzSpan]="24">
                    <nz-date-picker
                      class="width-100"
                      formControlName="endTime"
                      nzShowTime
                      nzAllowClear
                      nzFormat="yyyy-MM-dd HH:mm:ss"
                      nzPlaceHolder="Select End Time"
                    ></nz-date-picker>
                  </nz-form-control>
                </nz-form-item>
              </div>
              <div
                nz-col
                nzLg="8"
                nzMd="8"
                nzSm="24"
                nzXs="24"
                *ngIf="
                  addUpdateAnnouncementForm.get('countDown.enabled')?.value
                "
              >
                <nz-form-item>
                  <nz-form-label [nzSpan]="24">Countdown Label</nz-form-label>
                  <nz-form-control [nzSpan]="24">
                    <input
                      nz-input
                      formControlName="label"
                      type="text"
                      placeholder="e.g. Sale Ending In"
                    />
                  </nz-form-control>
                </nz-form-item>
              </div>
            </div>
          </div>

          <!-- Start Date -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Start Date</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                nzErrorTip="Please select start date"
              >
                <nz-date-picker
                  class="width-100"
                  formControlName="startDate"
                  nzShowTime
                  nzAllowClear
                  nzFormat="yyyy-MM-dd HH:mm:ss"
                  nzPlaceHolder="Select Start Date & Time"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- End Date -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>End Date</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                nzErrorTip="Please select end date"
              >
                <nz-date-picker
                  class="width-100"
                  formControlName="endDate"
                  nzShowTime
                  nzAllowClear
                  nzFormat="yyyy-MM-dd HH:mm:ss"
                  nzPlaceHolder="Select End Date & Time"
                ></nz-date-picker>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Status -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Status</nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
                <nz-radio-group formControlName="status">
                  <label nz-radio nzValue="active">Active</label>
                  <label nz-radio nzValue="inactive">Inactive</label>
                </nz-radio-group>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Module -->
          <div nz-col nzLg="12" nzMd="12" nzSm="24" nzXs="24">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired>Module</nz-form-label>
              <nz-form-control
                [nzSpan]="24"
                nzErrorTip="Please select a module"
              >
                <nz-select
                  nzAllowClear
                  formControlName="module"
                  nzPlaceHolder="Select module"
                  (ngModelChange)="onModuleChange($event)"
                >
                  <nz-option
                    *ngFor="let m of moduleList"
                    [nzValue]="m.value"
                    [nzLabel]="m.label"
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <!-- Reference Item -->
          <div
            nz-col
            nzLg="12"
            nzMd="12"
            nzSm="24"
            nzXs="24"
            *ngIf="addUpdateAnnouncementForm.get('module')?.value"
          >
            <nz-form-item>
              <nz-form-label
                [nzSpan]="24"
                [nzRequired]="
                  addUpdateAnnouncementForm.get('module')?.value === 'testSery'
                "
              >
                Select
                {{
                  getModuleLabel(addUpdateAnnouncementForm.get("module")?.value)
                }}
              </nz-form-label>
              <nz-form-control [nzSpan]="24" nzErrorTip="Please select an item">
                <nz-select
                  nzAllowClear
                  nzShowSearch
                  nzServerSearch
                  formControlName="referenceId"
                  [nzPlaceHolder]="
                    'Search ' +
                    getModuleLabel(
                      addUpdateAnnouncementForm.get('module')?.value
                    )
                  "
                  [nzLoading]="moduleLoading"
                  (nzOnSearch)="onModuleSearch($event)"
                  (nzScrollToBottom)="loadMoreModuleData()"
                >
                  <nz-option
                    *ngFor="let item of moduleData"
                    [nzValue]="item._id"
                    [nzLabel]="
                      getModuleItemLabel(
                        addUpdateAnnouncementForm.get('module')?.value,
                        item
                      )
                    "
                  ></nz-option>
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <!-- Right Column: Image Upload -->
      <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired
            >Announcement Image(1080px X 1440px)</nz-form-label
          >
          <nz-upload
            class="upload-list-inline"
            [nzAction]="mediaUploadUrl"
            [nzHeaders]="customRequestHeaders"
            [nzBeforeUpload]="beforeRelatedMediaUpload"
            [nzShowUploadList]="false"
            (nzChange)="UploadImageFile($event)"
          >
            <button
              nz-button
              *ngIf="!addUpdateAnnouncementForm.value.image"
              [nzLoading]="imageLoading"
            >
              <span nz-icon nzType="upload"></span>
              Upload
            </button>
          </nz-upload>

          <div
            class="image-preview-card"
            *ngIf="addUpdateAnnouncementForm.value.image"
          >
            <div class="image-preview-wrapper">
              <img
                nz-image
                class="image-preview-img"
                [nzSrc]="mediaBaseUrl + addUpdateAnnouncementForm.value.image"
              />
            </div>
            <div class="image-action-row">
              <a
                nz-button
                nzType="text"
                nzTooltipTitle="Download"
                nz-tooltip
                [href]="mediaBaseUrl + addUpdateAnnouncementForm.value.image"
                target="_blank"
                download
                class="image-action-btn image-action-download"
              >
                <span nz-icon nzType="download"></span>
              </a>
              <button
                nz-button
                nzType="text"
                nzDanger
                nzTooltipTitle="Delete"
                nz-tooltip
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to delete this image?"
                (nzOnConfirm)="
                  removeImage(addUpdateAnnouncementForm.value.image)
                "
                class="image-action-btn image-action-delete"
              >
                <span nz-icon nzType="delete"></span>
              </button>
            </div>
          </div>
        </nz-form-item>
      </div>
    </div>
  </nz-card>

  <!-- Submit Button -->
  <div nz-row nzJustify="end" class="mt3">
    <button
      nz-button
      nzType="primary"
      [nzLoading]="buttonLoading"
      (click)="submit()"
    >
      {{ idForUpdate ? "Update" : "Submit" }}
    </button>
  </div>
</form>
